import { SendAuctionACommand } from './SendAuctionACommand'
import { ConcatenatedBatches, AuctionAQueryRepository, AuctionACommandRepository } from '@/Domain/AuctionA'
import { ProcedureId } from '@/Domain/Procedures'
import { AccountId } from '@/Domain/Account'

export class SendAuctionACommandHandler {
  private _queryRepository: AuctionAQueryRepository
  private _commandRepository: AuctionACommandRepository

  constructor (queryRepository: AuctionAQueryRepository, commandRepository: AuctionACommandRepository) {
    this._queryRepository = queryRepository
    this._commandRepository = commandRepository
  }

  async handle (command: SendAuctionACommand): Promise<boolean> {
    try {
      const procedureId = new ProcedureId(command.procedureId())
      const accountId = new AccountId(command.userId())
      const concatenatedBatches = new ConcatenatedBatches(command.concatenatedBatches())
      const data = this._queryRepository.readAuctionAData()
      const response = await this._commandRepository.sendAuctionAData(procedureId, accountId, concatenatedBatches, data)
      return response
    } catch (error) {
      return Promise.reject(error)
    }
  }
}
